import { gql } from "graphql-tag";

export const WalletUpdatedSubscriptionGQL = gql`
  subscription WalletUpdated {
    walletUpdated {
      walletId
      name
      userId
      externalId
      type
      currency
      balance
      availableBalance
      sequence
      escrowId
      isClosed
      eventType
      updatedFields
    }
  }
`;
